import { render, staticRenderFns } from "./TopStanding.vue?vue&type=template&id=5aae69bc&"
import script from "./TopStanding.vue?vue&type=script&lang=js&"
export * from "./TopStanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports